// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/greetings/greetings.component.scss
// module id = 747
// module chunks = 0